import React from "react";

const PinkButton = ({ text, icon }) => {
  return (
    <div className="">
      <button
        type="submit"
        className="cursor-pointer	group relative w-full flex justify-center p-2 md:p-3 border border-transparent  md:text-base font-medium rounded-lg text-white bg-red active:bg-pink-400 focus:outline-none focus:ring-0 "
      >
        {icon ? <img src={icon} alt="Login" className="px-6 md:px-14" /> : text}
      </button>
    </div>
  );
};

export default PinkButton;
